import { render, staticRenderFns } from "./HistoryLayer.vue?vue&type=template&id=6cdd3a56&"
import script from "./HistoryLayer.vue?vue&type=script&lang=ts&"
export * from "./HistoryLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports